import { makeDoubleArgHook } from "../../utils/makeDoubleArgHook";
import { findPortfolioPlanAssignments, url, } from "../request/findPortfolioPlanAssignment";
function keyMaker(filters, pagination) {
    if (pagination === null && filters === null) {
        return [url(null, null)];
    }
    return [url(null, null), url(filters, pagination)];
}
const useGetPortfolioPlanAssignments = makeDoubleArgHook(findPortfolioPlanAssignments, keyMaker);
export default useGetPortfolioPlanAssignments;
//# sourceMappingURL=useFindPortfolioPlanAssignment.js.map